import { useRouter } from "next/router";
import { useSupabaseClient, useUser } from "@supabase/auth-helpers-react";
import FoodPreferencesIcon from "@/ui/Icons/FoodPreferencesIcon";
import RightArrowRoundedIcon from "@/ui/Icons/RightArrowRoundedIcon";
import PersonalInfoIcon from "@/ui/Icons/PersonalInfoIcon";
import SettingsIcon from "@/ui/Icons/SettingsIcon";
import LogoutIcon from "@/ui/Icons/LogoutIcon";
import { useEffect, useState } from "react";
import Image from "next/image";
import HeartOutline from "@/ui/Icons/HeartOutline";
import InviteIcon from "@/ui/Icons/InviteIcon";
import Loader from "@/components/Loaders/Loader";
import { useIntercom } from "@/contexts/intercom/IntercomProvider";
import { MdOutlineContactSupport } from "react-icons/md";
import NavBar from "@/components/NavBar/NavBar";
import CalendarSearch from "@/ui/Icons/CalendarSearch";
import BuyMeADinnerButton from "@/components/Button/BuyMeADinnerButton";

export default function Profile() {
  const user = useUser();
  const router = useRouter();
  const supabaseClient = useSupabaseClient();
  const [userPersona, setUserPersona] = useState<any>();
  const [referralDash, setReferralDash] = useState<any>(null);
  const { shutdown } = useIntercom();
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const storedValue = localStorage.getItem("isCalendarsChecked");
    if (storedValue !== null) {
      setIsChecked(JSON.parse(storedValue));
    }
  }, []);

  const handleCheckboxChange = () => {
    localStorage.setItem("isCalendarsChecked", JSON.stringify(!isChecked));
    setIsChecked(!isChecked);
  };

  const fetchUserPersona = async () => {
    const { data: persona } = await supabaseClient
      .from("user_persona")
      .select("*")
      .eq("user_id", user?.id)
      .limit(1)
      .single();
    if (persona) {
      setUserPersona(persona);
    }
  };

  const { show } = useIntercom();

  useEffect(() => {
    if (!user) {
      router.push("/signin");
    } else {
      fetchUserPersona();
      if (typeof (window as any).Tuemilio == "undefined") {
        (
          (function (t: any, u: any, e: any, m: any, i: any, l: any, io: any) {
            t["TuemilioObject"] = m;
            t[m] =
              t[m] ||
              function () {
                (t[m].q = t[m].q || []).push(arguments);
              };
            t[m].id = process.env.NEXT_PUBLIC_TUEMILIO_KEY;
            (l = u.createElement(e)), (io = u.getElementsByTagName(e)[0]);
            l.id = m;
            l.src = i;
            l.async = 1;
            io.parentNode.insertBefore(l, io);
          }) as any
        )(
          window,
          document,
          "script",
          "Tuemilio",
          "https://tuemilio.com/assets/js/modal/4.0/tuemilio-modal.js"
        );
        (window as any).Tuemilio("init", {
          form: {
            disabled: true,
          },
          dashboard: {
            disabled: true,
          },
        });
      }
      (window as any)?.Tuemilio("getDashboard", {
        address: user?.email,
      }),
        (window as any)?.Tuemilio("onDashboardData", function (dashboard: any) {
          setReferralDash(dashboard);
        }),
        (window as any).Tuemilio("onSubscriberUnidentified", function () {
          (window as any).Tuemilio("createSubscriber", {
            address: user.email,
          }),
            (window as any)?.Tuemilio("getDashboard", {
              address: user?.email,
            });
        });
    }
  }, [user]);

  return (
    <div className={"bg-[#F9F7F7] h-screen w-screen"}>
      <div className="w-full max-w-lg mx-auto">
        <NavBar heading="Profile" headingCenter={true} backURL="/" />
        <div className={"px-[30px]"}>
          <section className="pt-[26px]">
            <article className="flex flex-col gap-x-4 items-center ">
              <button className="relative w-[128px] h-[128px] rounded-full border border-[#F5BBD0] p-[4px]">
                <Image
                  width={120}
                  height={120}
                  className="object-cover w-full h-full rounded-full bg-[#FBE4EC]"
                  src={
                    user?.user_metadata?.picture ??
                    (userPersona?.family_role === null
                      ? "/avatar2.png"
                      : (userPersona?.family_role === "Mom" &&
                          "/memoji/Mom.png") ||
                        (userPersona?.family_role === "Dad" &&
                          "/memoji/Dad.png") ||
                        (userPersona?.family_role === "Son" &&
                          "/memoji/Son.png") ||
                        (userPersona?.family_role === "Daughter" &&
                          "/memoji/Daughter.png"))
                  }
                  alt={
                    user?.user_metadata?.full_name ?? user?.user_metadata?.name
                  }
                />
                {/*<div*/}
                {/*    className={"bg-[#1B6458] w-[30px] h-[30px] flex items-center p-[10px] rounded-full absolute top-0 right-[5px]"}>*/}
                {/*    <EditPencilIcon/>*/}
                {/*</div>*/}
              </button>
              <div className="py-[25px]">
                <h1 className="text-[#343233] font-semibold text-[24px] text-center">
                  {user?.user_metadata?.full_name ?? user?.user_metadata?.name}
                </h1>
                <p className="text-[#656364] text-[16px] text-center font-normal">
                  {user?.user_metadata?.phone ?? user?.user_metadata?.email}
                </p>
              </div>
            </article>
          </section>

          <button
            className="flex justify-between items-center border-2 border-[#15BC6EB8] bg-gradient-to-r to-[#FBED96] from-[#ABECD6] rounded-[24px] px-[15px] py-[10px] cursor-pointer w-full"
            onClick={() => router.push("/user/invite")}
          >
            <div className={"flex align-middle items-center"}>
              <div className={"p-[5px]"}>
                <InviteIcon />
              </div>
              <p className={"px-[10px] font-medium"}>Invite Friends</p>
            </div>
            <div className={"p-[5px] font-medium flex items-center"}>
              {referralDash ? (
                <>{referralDash?.subscriber?.points}</>
              ) : (
                <Loader size={5} />
              )}{" "}
              💎
            </div>
          </button>

          <section className={"py-[25px]"}>
            <div className="flex flex-col bg-white rounded-[24px] px-[15px] py-[10px] divide-y-[1px]">
              <div className="w-full flex justify-between py-[10px]">
                <div className={"flex align-middle items-center"}>
                  {/*icon*/}
                  <div className={"p-[5px]"}>
                    <CalendarSearch color="#007D32" />
                  </div>
                  {/*text*/}
                  <p className={"px-[10px] font-medium"}>Calendar View</p>
                </div>
                {/*right arrow*/}
                <div className={"p-[5px]"}>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      value=""
                      className="sr-only peer"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#007D32]"></div>
                  </label>
                </div>
              </div>

              <button
                className="w-full flex justify-between py-[10px]"
                onClick={() => router.push("/user/food-preferences")}
              >
                <div className={"flex align-middle items-center"}>
                  {/*icon*/}
                  <div className={"p-[5px]"}>
                    <FoodPreferencesIcon />
                  </div>
                  {/*text*/}
                  <p className={"px-[10px] font-medium"}>Food preferences</p>
                </div>
                {/*right arrow*/}
                <div className={"p-[5px]"}>
                  <RightArrowRoundedIcon />
                </div>
              </button>

              <button
                className="w-full  flex justify-between py-[10px]"
                onClick={() => router.push("/user/personal-info")}
              >
                <div className={"flex align-middle items-center"}>
                  {/*icon*/}
                  <div className={"p-[5px]"}>
                    <PersonalInfoIcon />
                  </div>
                  {/*text*/}
                  <p className={"px-[10px] font-medium"}>Personal Info</p>
                </div>
                {/*right arrow*/}
                <div className={"p-[5px]"}>
                  <RightArrowRoundedIcon />
                </div>
              </button>

              <button
                className="w-full  flex justify-between py-[10px]"
                onClick={() => router.push("/user/settings")}
              >
                <div className={"flex align-middle items-center"}>
                  {/*icon*/}
                  <div className={"px-[5px] py-[3px]"}>
                    <SettingsIcon />
                  </div>
                  {/*text*/}
                  <p className={"px-[10px] font-medium"}>Settings</p>
                </div>
                {/*right arrow*/}
                <div className={"p-[5px]"}>
                  <RightArrowRoundedIcon />
                </div>
              </button>

              <button
                className="w-full  flex justify-between py-[10px]"
                onClick={() => router.push("/recipe-status")}
              >
                <div className={"flex align-middle items-center"}>
                  {/*icon*/}
                  <div className={"px-[5px] py-[3px]"}>
                    <HeartOutline />
                  </div>
                  {/*text*/}
                  <p className={"px-[10px] font-medium"}>
                    {/*Recipe Box*/}Recipe GPT
                  </p>
                </div>
                {/*right arrow*/}
                <div className={"p-[5px]"}>
                  <RightArrowRoundedIcon />
                </div>
              </button>

              {/*<button*/}
              {/*    className="w-full  flex justify-between py-[10px]"*/}
              {/*    onClick={() => router.push(`/onboarding?guid=${user?.id}`)}*/}
              {/*>*/}
              {/*  <div className={"flex align-middle items-center"}>*/}
              {/*    /!*icon*!/*/}
              {/*    <div className={"px-[5px] py-[3px]"}>*/}
              {/*      <SettingsIcon />*/}
              {/*    </div>*/}
              {/*    /!*text*!/*/}
              {/*    <p className={"px-[10px] font-medium"}>Complete Onboarding</p>*/}
              {/*  </div>*/}
              {/*  /!*right arrow*!/*/}
              {/*  <div className={"p-[5px]"}>*/}
              {/*    <RightArrowRoundedIcon />*/}
              {/*  </div>*/}
              {/*</button>*/}

              <button
                className="w-full  flex justify-between py-[10px]"
                onClick={async () => {
                  await supabaseClient.auth.signOut();
                  shutdown();
                  await router.push("/");
                }}
              >
                <div className={"flex align-middle items-center"}>
                  {/*icon*/}
                  <div className={"px-[5px] py-[3px]"}>
                    <LogoutIcon />
                  </div>
                  {/*text*/}
                  <p className={"px-[10px] font-medium"}>Logout</p>
                </div>
                {/*right arrow*/}
                <div className={"p-[5px]"}>
                  <RightArrowRoundedIcon />
                </div>
              </button>
              <button
                className="w-full  flex justify-between py-[10px]"
                onClick={show}
              >
                <div className={"flex align-middle items-center"}>
                  {/*icon*/}
                  <div className={"px-[5px]"}>
                    <MdOutlineContactSupport color={"027D32"} size={22} />
                  </div>
                  {/*text*/}
                  <p className={"px-[10px] font-medium"}>Help</p>
                </div>
                {/*right arrow*/}
                <div className={"p-[5px]"}></div>
              </button>
            </div>
          </section>
          <div>
            <div
              className={"w-full flex flex-col justify-between items-center"}
            >
              <p className={"py-2 text-center"}>Help us keep Dinnerfy free.</p>
              {/* Other content */}
              <BuyMeADinnerButton />
              {/* Other content */}
            </div>
            <a
              href={"https://lamatic.ai"}
              target={"_blank"}
              className={"flex justify-center py-10"}
            >
              <div>Built with</div>
              <img
                src={
                  "https://assets-global.website-files.com/65573f6af6e5e7488775bdae/65829c89e420b3d198c523f8_lamatic.png"
                }
                className={"h-[25px] mx-1 lamatic"}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
